import { useState } from 'react'
import { Box, Button, Divider } from '@mui/material'

import { getCurrentUser } from '@/utils/auth/UserProvider'
import ResetPassword from '@/components/ResetPassword'
import LinkAccountModal from '@/components/LinkAccount'

export default function AccountSecuritySettings() {
  const { user, token } = getCurrentUser()
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false)
  const [showLinkAccountModal, setShowLinkAccountModal] = useState(false)

  const canResetPassword = !!user?.auth0_id?.startsWith('auth0|')

  return (
    <>
      {showResetPasswordModal && (
        <ResetPassword
          email={user?.email || ''}
          showResetPasswordModal={showResetPasswordModal}
          setShowResetPasswordModal={setShowResetPasswordModal}
          token={token}
        />
      )}
      {showLinkAccountModal && (
        <LinkAccountModal
          showLinkAccountModal={showLinkAccountModal}
          setShowLinkAccountModal={setShowLinkAccountModal}
          token={token}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Divider sx={{ mt: 8, mb: 2, width: '80%' }}>Login & Security</Divider>

        {canResetPassword && (
          <Button
            variant="text"
            disableRipple
            sx={{
              textTransform: 'none',
              borderRadius: 0,
              '&:focus': {
                backgroundColor: '#e8e8e8',
              },
            }}
            onClick={() => setShowResetPasswordModal(true)}
          >
            Reset my password
          </Button>
        )}

        <Button
          variant="text"
          disableRipple
          sx={{
            textTransform: 'none',
            '&:focus': {
              backgroundColor: '#e8e8e8',
            },
          }}
          onClick={() => setShowLinkAccountModal(true)}
        >
          Manage my Login Methods
        </Button>
      </Box>
    </>
  )
}
